// All action times

const managePlans = {
  REQUEST_CHANGEPLAN: 'REQUEST_CHANGEPLAN',
  RECEIVE_CHANGEPLAN: 'RECEIVE_CHANGEPLAN',
  REQUEST_STORAGEINFO: 'REQUEST_STORAGEINFO',
  RECEIVE_STORAGEINFO: 'RECEIVE_STORAGEINFO',
  ERROR_CHANGEPLAN: 'ERROR_CHANGEPLAN'
}

export default managePlans



// WEBPACK FOOTER //
// src/routes/ManagePlans/actions/actionTypes.js